import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getDeviationType } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import {
  DeviationOriginalFile,
  getDeviationOriginalFile,
} from '@wix/da-shared-react/pkg/utils/deviations';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import MediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';
import { getResponseDeviation } from '../../redux/selectors';
import FieldsGroup from '../../layouts/common/FieldsGroup';
import DisplayOptionsField from '../../fields/DisplayOptionsField';
import { MIN_SIZE_FOR_WATERMARK } from '../../fields/AddWatermarkField/AddWatermarkField';

import s from './DisplayOptionsForm.scss';

const DisplayOptionsForm: React.FC<{}> = () => {
  const { t } = useTranslation();
  const deviation = useSelector(state => getResponseDeviation(state));
  const isFilm = getDeviationType(deviation) === DeviationTypes.FILM;
  const isGif = !!deviation && MediaService.isGif(deviation);
  const originalFile: DeviationOriginalFile = getDeviationOriginalFile(deviation);
  const { width = 0, height = 0 } = originalFile ?? {};
  const isTooSmallForDisplayOpts =
    width < MIN_SIZE_FOR_WATERMARK && height < MIN_SIZE_FOR_WATERMARK;

  if (isFilm || isGif || isTooSmallForDisplayOpts) {
    // Display options aren't applicable
    return null;
  }

  return (
    <div>
      <FieldsGroup
        title={t('deviationSubmit.form.section.displayOptions.title')}
        titleClassName={s['title']}
      >
        <DisplayOptionsField />
      </FieldsGroup>
    </div>
  );
};
DisplayOptionsForm.displayName = 'DisplayOptionsForm';

export default DisplayOptionsForm;
